import { Flex, Module, SkeletonText, Spacing } from '@billy/design-system'

export const ContactDetailSkeleton = () => (
  <Flex flexDirection="column" gap={Spacing.S32}>
    <Module>
      <Module.Section>
        <Flex flexDirection="column" gap={Spacing.S12}>
          <SkeletonText width={80} />
          <SkeletonText width={160} />
          <SkeletonText width={80} />
          <SkeletonText width={280} />
        </Flex>
      </Module.Section>
    </Module>
    <Flex flexDirection="column" gap={Spacing.S12}>
      <SkeletonText width={270} />
      <Module>
        <Module.Section>
          <Flex flexWrap="wrap" gap={Spacing.S12}>
            <Flex flexDirection="column" flexGrow={1} gap={Spacing.S12}>
              <SkeletonText fullWidth />
              <SkeletonText fullWidth />
              <SkeletonText fullWidth />
              <SkeletonText fullWidth />
            </Flex>
            <Flex flexDirection="column" flexGrow={1} gap={Spacing.S12}>
              <SkeletonText fullWidth />
              <SkeletonText fullWidth />
              <SkeletonText fullWidth />
              <SkeletonText fullWidth />
            </Flex>
            <Flex flexDirection="column" flexGrow={1} gap={Spacing.S12}>
              <SkeletonText fullWidth />
              <SkeletonText fullWidth />
              <SkeletonText fullWidth />
              <SkeletonText fullWidth />
            </Flex>
          </Flex>
        </Module.Section>
      </Module>
    </Flex>
  </Flex>
)
